export default "__VITE_ASSET__ObrGWUpy__"